import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.z4r_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.w4r_1;
    if (index >= interceptors.q2()) {
      $this.a4s();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.z4r_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.y4r_1, $completion);
  }
   while (true);
  return $this.y4r_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.w4r_1 = interceptors;
        this.x4r_1 = coroutineContext;
        this.y4r_1 = subject;
        this.z4r_1 = 0;
      }
      dw() {
        return this.x4r_1;
      }
      b4s() {
        return this.y4r_1;
      }
      a4s() {
        this.z4r_1 = -1;
      }
      *c4s(subject, $completion) {
        this.y4r_1 = subject;
        return yield* this.d4s($completion);
      }
      *d4s($completion) {
        var index = this.z4r_1;
        if (index < 0)
          return this.y4r_1;
        if (index >= this.w4r_1.q2()) {
          this.a4s();
          return this.y4r_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *e4s(initial, $completion) {
        this.z4r_1 = 0;
        this.y4r_1 = initial;
        return yield* this.d4s($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
